module.exports = __webpack_public_path__ + "img/interpackmaxi_cod_dg.438745a1.png";